import { createTestIds } from '../../utils';

export const getFullscreenTestIds = createTestIds('fullscreen', [] as const);
